export function ButtonLink({ children, otherClass, onClick, disabled }) {

    return (
        <button type="button" className={`btn btn-link text-dark p-1 ${otherClass ? otherClass : ""} ${disabled ? 'disabled opacity-25' : ''}`}
            disabled={disabled}
            onClick={onClick}>
            {children}
        </button>
    );
}